import React from 'react';

import NewsEventsBody from '../components/NewsEventsBody';

import NewsEventsModuleContext from '../context/NewsEventsModuleContext';
import NewsEventsModuleContainer from '../containers/NewsEventsModuleContainer';

const NewsEventsModuleLayout = () => (
  <NewsEventsModuleContainer>
    <NewsEventsModuleContext.Consumer>
      {value => (
        <div>
          <section className="news-events-body-wrap">
            <NewsEventsBody {...value} module />
          </section>
        </div>
      )}
    </NewsEventsModuleContext.Consumer>
  </NewsEventsModuleContainer>
);

export default NewsEventsModuleLayout;
